/**
 * PostHog browser bundle (local, CSP-safe)
 *
 * Replaces the inline PostHog loader snippet that was duplicated across views.
 * That snippet injected a <script> pointing at `<posthog host>/static/array.js`,
 * which is exactly the CDN pattern .cursor/rules/csp-libraries.mdc forbids: it
 * required 'unsafe-inline' in scriptSrc and put analytics availability at the
 * mercy of a third-party host.
 *
 * `module.full.no-external` is the variant that bundles the session-replay
 * recorder and surveys in-tree. The plain `module.full` build still lazy-loads
 * some chunks from the PostHog host at runtime, which would defeat the point of
 * vendoring it, so do not "simplify" this require path.
 *
 * The recorder spawns its image-compression web worker from a blob URL, which is
 * why the CSP in server.js needs `workerSrc: 'self' blob:`.
 *
 * Exposed on window because posthog-client.js and the view partials consume it
 * as a global rather than as a module.
 */

// require() rather than import, to match the other webpack entries in this
// directory (the ESLint config parses src/js as CommonJS script). Not named
// `posthog`, which is already declared as a browser global for client code.
const posthogModule = require('posthog-js/dist/module.full.no-external');

window.posthog = posthogModule.default || posthogModule;
